import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center">
              <div className="h-8 w-8 rounded-lg bg-white flex items-center justify-center">
                <span className="text-gray-900 font-bold text-sm">WB</span>
              </div>
              <span className="ml-2 text-xl font-bold">Greenlight</span>
            </div>
            <p className="mt-4 text-gray-400">
              Защита карточек товаров на Wildberries с помощью ИИ
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Продукт</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="/#features" className="hover:text-white">
                  Возможности
                </a>
              </li>
              <li>
                <a href="/#how-it-works" className="hover:text-white">
                  Как это работает
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white">
                  API
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Компания</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-white">
                  О нас
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white">
                  Блог
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white">
                  Контакты
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white">
                  Вакансии
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Правовая информация</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/offer" className="hover:text-white">
                  Политика конфиденциальности
                </Link>
              </li>
              <li>
                <Link to="/offer" className="hover:text-white">
                  Условия использования
                </Link>
              </li>
              <li>
                <Link to="/requisites" className="hover:text-white">
                  Реквизиты
                </Link>
              </li>
              <li className="flex items-center mt-4">
                <span className="text-sm">🇷🇺 Сделано в России</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>© 2026 WB Greenlight. ИНН 180805638897. Все права защищены.</p>
          <p className="mt-2">kamran@kurbanov.me</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer